
import Base from "@/components/Text/Base.vue";

export default class Whole extends Base {
  id = "whole";
  defaultText = "Covering the whole image";
}
